import { useRef } from "react";
var useAutoFit = function () {
    var ref = useRef(null);
    var setAutoFit = function () {
        setTimeout(function () {
            ref.current && (ref.current.style.height = "calc(100vh - ".concat(ref.current.offsetTop, "px)"));
        }, 400);
    };
    return [ref, setAutoFit];
};
export default useAutoFit;
